import { mapGetters } from 'vuex';
import sheetResourcesGetter from '@/mixins/sheet/sheetResourcesGetter';

export default {
    mixins: [sheetResourcesGetter],
    computed: {
        ...mapGetters('sheet', ['getPossessionsQuestions']),
        livingConditionsTypeResource () {
            return this.getResources(this.getPossessionsQuestions.living_conditions.type);
        }
    }
};
